import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const ClientDashboardPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Клиентская панель
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Клиентская панель в разработке...
        </Typography>
      </Box>
    </Container>
  );
};

export { ClientDashboardPage };